import { tsValidateString, tsValidateValue } from '@nu-art/ts-common';
import { smartDocStaticParamType_ChiefComplaint } from './types.js';
import { Validator_SmartDocStaticParamType } from '../_base/index.js';
import { Validator_SmartDocParmaResolver_VariableResolver } from '../../../smart-doc-param-resolver/index.js';
export const Validator_SmartDocStaticParam_ChiefComplaint = {
    key: tsValidateString(),
    type: Validator_SmartDocStaticParamType,
    subType: tsValidateValue([smartDocStaticParamType_ChiefComplaint]),
    resolver: Validator_SmartDocParmaResolver_VariableResolver,
};
//# sourceMappingURL=validator.js.map